import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import dayjs from 'dayjs'
import BaseService from 'services/BaseService'
import { notificationConfig } from './constants'
import { formatDateTime }  from '../../functions/formatDate'

// Redux Toolkit slice
const statistiquesTresoreriesSlice = createSlice({
    name: 'statistiquesTresoreries',
    initialState: {
        data: [],
        isLoading: false,
        error: null,
        created: null,
        isDeleted: null,
        currentPage: 1,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchStatistiquesTresoreries.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(fetchStatistiquesTresoreries.fulfilled, (state, action) => {
                const currentPage = action?.meta?.arg?.page || state.currentPage;

                state.currentPage = currentPage
                state.isLoading = false
                state.data = action.payload
            })
            .addCase(fetchStatistiquesTresoreries.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
            })
            
    },
})

// Async thunk action to fetch data from the API
export const fetchStatistiquesTresoreries = createAsyncThunk(
    'statistiquesTresoreries/fetch',
    async ({ startDate, endDate }) => {
        
        // Check for existence of startDate and endDate
        if (!startDate || !endDate) {
            throw new Error('Missing startDate or endDate');
        }
        
        try {
            const response = await BaseService.get(
                `/XML/tr.stat.load?startDate=${formatDateTime(startDate)}&endDate=${formatDateTime(endDate)}`
            )
            return response.data
        } catch (error) {
            throw new Error('Failed to fetch statistiquesTresoreries')
        }
    }
)




export const selectData = (state) => state.statistiquesTresoreries.data
export const selectIsLoading = (state) => state.statistiquesTresoreries.isLoading
export const selectError = (state) => state.statistiquesTresoreries.error

export default statistiquesTresoreriesSlice.reducer
